export const structuredClone = globalThis.structuredClone;
//# sourceMappingURL=structuredClone.js.map